export default class TypeRateCCSS {
  id!: number
  tariff_type!: string
  isEdit!: boolean
}
